<template>
  <BasicLayout>
    <template #wrapper>
      <today />

    </template>
  </BasicLayout>
</template>

<script>
import today from '@/views/config/spins-consume/compents/today.vue'

export default {
  name: 'SpinsConsumeDay',
  components: {
    today
  },
  data() {
    return {
    }
  },
  created() {

  },
  methods: {

  }
}
</script>

<style scoped>
</style>
